import { createStyles } from 'core/utilities/theme';

export default createStyles({
  label: {
    marginBottom: '6px',
  },
  checkbox: {
    padding: '3px 8px 3px 6px',
  },
});
